export const SEARCH_USER = 'SEARCH_USER';
export const SEARCH_USER_DATA = 'SEARCH_USER_DATA';
export const SELECTED_USER = 'SELECTED_USER';




